export default function ($rootScope, $filter, timetableService, storageService, alertsService, $uibModal, timetableConfig) {

    var data = {
        onlineCourseCount: 0,
        onlineClassCount: 0,
        addedToPlanner: [],
        planner: []
    };

    /* the modal, keep these templates out of the main html view */
    var removeModalTemplate =
        '<div class="modal-header">' +
        '   <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="cancel()"><span aria-hidden="true" class="fa fa-xmark"></span></button>' +
        '   <h4 class="modal-title" id="update-modal-label">Are you sure?</h4>' +
        '</div>' +
        '<div class="modal-body">' +
        '   <p>Removing a course will remove all associated classes from the planner.</p>' +
        '</div>' +
        '<div class="modal-footer">' +
        '   <button class="btn btn-success" ng-click="ok()">OK</button>' +
        '   <button class="btn btn-default" ng-click="cancel()">Cancel</button>' +
        '</div>';

    /**
     * Build the empty planner view
     * @returns {} 
     */
    function scaffold() {
        var i, j, l = timetableConfig.DAYS.length, o, temp = [];

        for (i = 0; i < l; i++) {

            o = {};
            o.name = timetableConfig.DAYS[i];
            o.hours = [];

            // 15-> 16 to add extra spot for online
            for (j = 0; j < 16; j++) {
                o.hours.push({ 'classes': [] });
            }
            temp.push(o);
            data.planner.push(o);
        }

        return temp;
    }

    /**
     * Emit the change event, this is available for subscription via subscribe()
     * @returns {} 
     */
    function notify() {
        $rootScope.$emit('plannerChanged', data);
    }

    /**
     * Add the course/class to the planner object
     * @param {} c 
     * @param {} courseCode 
     * @param {} description 
     * @param {} courseId 
     * @param {} termId 
     * @param {} fromModal 
     * @param {} courses 
     * @returns {} 
     */
    function addToPlanner(c, courseCode, description, courseId, termId, fromModal) {

        var classes;
        // need to fetch the courses from the service, which returns a promise, hence the closure
        timetableService.getClasses(c.courseId, termId)
            .then(function (r) {
                classes = r.data ? r.data.data : r;
                add();
            });

        function add() {

            var uniqueInPlanner = [];
            data.addedToPlanner.forEach(function (course) {
                if (uniqueInPlanner.indexOf(course.courseCode) === -1) {
                    uniqueInPlanner.push(course.courseCode);
                }
            });

            // show alert if:
            // there are six courses in the planner and the object to add is a course
            // there are six courses in the planner and the object to add is a class but the coursecode has not already been added
            if (uniqueInPlanner.length === timetableConfig.SIDEBAR_MAX &&
                (c === null || uniqueInPlanner.indexOf(courseCode) === -1 && c !== null)) {
                alertsService.add('danger', 'ERROR', 'Unable to add <i>' + courseCode + '</i>. Remove at least one selection and try again. Maximum selections is ' + timetableConfig.SIDEBAR_MAX);
            } else {

                // need to check for multiple instance of the same class id                
                // $scope.results[0].classes holds the class list for the current object if the search came from a typeahead selection
                // if it was character search, results needs to be iterated
                // multiDay.length will be >= 1 - either the class sent to addToPlanner, or a set of classes with matching classNo
                // results.length will be 0 if it's modal selection, so multiday just holds the class object, if one exists
                var i,
                    classesToAdd = [];

                if ((fromModal === undefined || fromModal !== true) && c !== null) {

                    if (classes) {
                        classes.forEach(function (currentClass) {
                            if (classesToAdd[0] === undefined && currentClass.classNo === c.classNo) {
                                classesToAdd.push(currentClass);
                            } else if (currentClass.classNo === c.classNo &&
                                currentClass.meetingDayNo !== c.meetingDayNo &&
                                (currentClass.meetingStartTime !== c.meetingStartTime &&
                                    currentClass.meetingEndTime !== c.meetingEndTime ||
                                    currentClass.classMeetingNo !== c.classMeetingNo)) {

                                classesToAdd.push(currentClass);
                            }
                        });
                    }

                } else if (c !== null && fromModal === true) {

                    angular.forEach(c,
                        function (currentClass) {
                            if (classesToAdd[0] === undefined) {
                                classesToAdd.push(currentClass);
                            }
                            if (classesToAdd.length > 1) {
                                angular.forEach(classesToAdd,
                                    function (currentClassB) {
                                        if (currentClass.meetingDayNo !== currentClassB.meetingDayNo &&
                                            (currentClass.meetingStartTime !== currentClassB.meetingStartTime &&
                                                currentClass.meetingEndTime !== currentClassB.meetingEndTime)) {
                                            classesToAdd.push(currentClass);
                                        }
                                    });
                            }
                        });
                }

                // online classes are often listed more than once, but should only be added once
                // remove all but a single instance of the online class
                var foundOnlineOffering = false;
                classesToAdd.forEach(function (v, i) {
                    if (foundOnlineOffering && v.room === 'ONLINE') {
                        classesToAdd.splice(1, i);
                    } else if (v.room === 'ONLINE') {
                        foundOnlineOffering = true;
                    }
                });

                for (i = 0; i < classesToAdd.length; i += 1) {

                    var classInstance = classesToAdd[i],
                        hasClash = false,
                        exactClash = false,
                        courseFound = false,
                        clash = null;

                    if (!classInstance.meetingDayNo) {
                        var startDate = new Date(classInstance.meetingStartDate);
                        classInstance.meetingDayNo = startDate.getDay() + 1; // our week starts on sunday, 1 index
                        classInstance.meetingDay = timetableConfig.DAYS[startDate.getDay()];
                    }

                    var classFound = data.addedToPlanner.where(function (plannerItem) {

                        if (plannerItem.courseCode === courseCode) {
                            courseFound = true;
                        }

                        if (classInstance && classInstance.room !== 'ONLINE') {
                            if (plannerItem &&
                                plannerItem.hasOwnProperty('class') &&
                                plannerItem.class.meetingDay === classInstance.meetingDay) {

                                // start times are the same = exact clash
                                var newItemStartDate = new Date(classInstance.meetingStartDate),
                                    newItemEndDate = new Date(classInstance.meetingEndDate),
                                    plannerItemStartDate = new Date(plannerItem.class.meetingStartDate),
                                    plannerItemEndDate = new Date(plannerItem.class.meetingEndDate);

                                // check both directions - existing may fall in new, new may fall in existing
                                // particularly relevant for single-date classes
                                if ((newItemStartDate < plannerItemEndDate && newItemStartDate >= plannerItemStartDate) ||
                                    (newItemEndDate <= plannerItemEndDate && newItemEndDate > plannerItemStartDate) ||
                                    (plannerItemStartDate < newItemEndDate && plannerItemStartDate >= newItemStartDate) ||
                                    (plannerItemEndDate <= newItemEndDate && plannerItemEndDate > newItemStartDate)) {

                                    var plannerItemStart = parseFloat($filter('date')(plannerItem.class.meetingStartTime, 'H.MM')),
                                        plannerItemEnd = parseFloat($filter('date')(plannerItem.class.meetingEndTime, 'H.MM')),
                                        newItemStart = parseFloat($filter('date')(classInstance.meetingStartTime, 'H.MM')),
                                        newItemEnd = parseFloat($filter('date')(classInstance.meetingEndTime, 'H.MM'));

                                    if (plannerItemStart === newItemStart) {
                                        hasClash = true;
                                        exactClash = true;
                                        clash = plannerItem;
                                    } else if (
                                        newItemStart > plannerItemStart && newItemStart < plannerItemEnd || // start of new overlaps
                                        newItemEnd > plannerItemStart && newItemEnd < plannerItemEnd || // end of new overlaps 
                                        plannerItemStart > newItemStart && plannerItemStart < newItemEnd || // start of existing overlaps
                                        plannerItemEnd > newItemStart && plannerItemEnd < newItemEnd) { // end of existing overlaps
                                        hasClash = true;
                                        clash = plannerItem;
                                    }
                                }
                            }

                            if (plannerItem && plannerItem.hasOwnProperty('id')) {
                                return plannerItem.id ===
                                    classInstance.classNo.toString() + classInstance.classMeetingNo.toString();
                            } else if (plannerItem && plannerItem.hasOwnProperty('class')) {
                                return plannerItem.class.classNo === classInstance.classNo;
                            }
                        }
                        return false;
                    }).length;

                    // allow multiday classes to clash start times
                    if (exactClash && classesToAdd.length === 1 && classInstance.classNo === clash.class.classNo) {
                        alertsService.add('danger',
                            'ERROR',
                            'Unable to add <i>' +
                            classInstance.classSection +
                            ' ' +
                            classInstance.classDesc +
                            '</i> - class is already in planner.');
                    } else {
                        // this will be classes where start/finish times overlap existing
                        if (hasClash) {
                            alertsService.add('danger', 'WARNING', classInstance.classSection + ' ' + classInstance.classDesc + ' clashes with ' + clash.class.classSection + ' ' + clash.class.classDesc);
                        }
                        if (classFound === 0 && classInstance !== null) {
                            // checkClashes flag prevents checking clashes when adding multiple classes at once
                            addClassToPlanner(classInstance,
                                courseCode,
                                description,
                                courseId,
                                termId,
                                false,
                                (classesToAdd.length === 1));
                        } else if (!courseFound) {
                            addCourseToPlanner(courseCode, description, courseId, termId, false);
                        }
                    }
                }

                // if adding multiple classes, warn the user of possible clashes and check planner for these
                if (classesToAdd.length > 1) {

                    alertsService.addAlert('danger', 'WARNING', classInstance.classSection + ' ' + classInstance.classDesc + ' is offered on different days each week and may conflict with existing classes.');

                    var day;
                    if (classesToAdd.length > 1) {
                        for (i = 0; i < classesToAdd.length; i++) {
                            day = data.planner.where(function (o) {
                                return o.name === classesToAdd[i].meetingDay;
                            })[0];

                            checkDayForClashes(day, true);
                        }
                    } else {
                        day = data.planner.where(function (o) {
                            return o.name === classInstance.meetingDay;
                        })[0];

                        checkDayForClashes(day, true);
                    }
                }
            }

            storageService.storePlanner(data.addedToPlanner);
            notify();
        }
    }

    function addClassToPlanner(c, courseCode, description, courseId, termId, checkUnique, checkClashes) {
        // the class object is nested within an object identifying the parent course by code and name

        var exists = false;
        if (checkUnique) {
            exists = data.addedToPlanner.where(function (existingElement) {
                if (c !== null) {
                    return existingElement.hasOwnProperty('id')
                        ? existingElement.id === c.classNo.toString() + c.classMeetingNo.toString()
                        : existingElement.classNo === c.classNo;
                }
                return true;
            }).length > 0 ? true : false;
        }

        var o = {
            'class': c,
            courseCode: courseCode,
            description: description,
            courseId: courseId,
            termId: termId,
            id: c.classNo.toString() + c.classMeetingNo.toString()
        };

        o.class.clash = '';
        o.class.red = '';
        o.class.meetingEndTime = $filter('date')(c.meetingEndTime, 'HH:MM');
        o.class.meetingStartTime = $filter('date')(c.meetingStartTime, 'HH:MM');
        o.class.duration = o.class.meetingEndTime ? (parseInt(o.class.meetingEndTime.replace(':', '')) - parseInt(o.class.meetingStartTime.replace(':', ''))) / 2 : 0;

        var day = data.planner.where(function (d) {
            return d.name === c.meetingDay;
        })[0];

        if (o.class.room === 'ONLINE') {
            day.hours[0].classes.push(o);
        } else {
            day.hours[Math.round((parseInt($filter('date')(o.class.meetingStartTime, 'HH:MM').replace(':', '')) - 600) / 100)].classes.push(o); // eg (1900 - 600) / 100 = 13, or 7pm -> 6am + 12hours, where the 6am cell is labelled 'online'
        }

        if (checkClashes !== false) {
            checkDayForClashes(day, true);
        }

        data.planner[o.class.meetingDayNo - 1].hasClasses = true;

        if (!exists) {
            data.addedToPlanner.push(o);
            alertsService.add('success', 'SUCCESS', 'Class <i>' + c.classSection + ' ' + c.classDesc + '</i> successfully added to planner.');
        }

        // find the day with the most online options added, set that count as the onlineClassCount value, which controls the height of the top row of the planner
        // online classes can't clash, so must stack instead.
        var x = 0;
        data.planner.forEach(function (day) {
            if (day.hours[0].classes.length > x) {
                x = day.hours[0].classes.length;
            }
        });
        data.onlineClassCount = x;
    }

    function checkDayForClashes(day, isAdd) {

        // if course removed, reset clash value for all existing
        var i, q, classes, j, r;
        if (!isAdd) {
            for (i = 0, q = day.hours.length; i < q; i++) {
                if (day.hours[i].classes.length > 0) {
                    classes = day.hours[i].classes;
                    for (j = 0, r = classes.length; j < r; j++) {
                        classes[j].class.clash = '';
                        classes[j].class.red = '';
                    }
                }
            }
        }

        // check each hour of the current day
        for (i = 0, q = day.hours.length; i < q; i++) {

            // if the hour has classes
            if (day.hours[i].classes.length > 0) {

                classes = day.hours[i].classes;

                // check each class in the current hour
                for (j = 0, r = classes.length; j < r; j++) {

                    var c = classes[j].class,
                        finishHour = c.meetingEndTime ? Math.round((parseInt(c.meetingEndTime.replace(':', '')) - 600) / 100) : i + c.duration;

                    if (c.room !== 'ONLINE') {
                        checkFollowingClasses(i, finishHour, c, day);
                    }
                }
            }
        }
    }

    function checkFollowingClasses(i, finishHour, c, day) {
        // given the start and finish time for the current class, check for others starting in the same period.
        var kClasses,
            kClass;

        for (i; i < finishHour; i++) {

            kClasses = day.hours[i].classes;

            if (kClasses.length > 0) {

                for (var l = 0, t = kClasses.length; l < t; l++) {

                    kClass = kClasses[l].class;

                    if ((c.classNo.toString() + c.classMeetingNo.toString()).toLowerCase() !==
                        (kClass.classNo.toString() + kClass.classMeetingNo.toString()).toLowerCase()) {

                        if (c.clash !== '') {
                            kClass.clash = c.clash === 'left' ? 'right' : 'left';
                        } else {
                            c.clash = 'left';
                            kClass.clash = 'right';
                        }

                        var newStartDate = new Date(c.meetingStartDate),
                            newEndDate = new Date(c.meetingEndDate),
                            kClassStartDate = new Date(kClass.meetingStartDate),
                            kClassEndDate = new Date(kClass.meetingEndDate);

                        if ((newStartDate < kClassEndDate && newStartDate >= kClassStartDate) ||
                            (newEndDate <= kClassEndDate && newEndDate > kClassStartDate)) {

                            c.red = true;
                            kClass.red = true;
                        }
                    }
                }
            }
        }
    }

    /**
     * manage removal of class/course from the planner, and related storage etc
     * @param {Object} c - will be removed from the planner array
     * @param {book} isCourse -indicates the object type, being course or class
     * @returns {} 
     */
    function removeFromPlanner(c, isCourse) {
        if (isCourse) {

            var modalInstance = $uibModal.open({
                template: removeModalTemplate,
                controller: 'RemoveCourseFromPlannerModalCtrl'
            });

            modalInstance.result.then(function (resp) {
                if (resp === true) {
                    doRemoveFromPlanner(c);
                }
            });
        } else {

            var classNo = null,
                courseId = null,
                hasClasses,
                day,
                hour,
                i,
                j,
                k,
                l,
                m,
                o;

            for (i = 0, j = data.planner.length; i < j; i++) {
                day = data.planner[i];
                hasClasses = false;

                for (k = 0, l = Object.size(day.hours); k < l; k++) {
                    hour = day.hours[Object.keys(day.hours)[k]];
                    m = Object.size(hour.classes);

                    if (m > 0) {
                        while (m--) {
                            o = hour.classes[m];
                            //two different methods of removing class from planner 
                            //one using class selection modal template by checking classNo and one using x button for class in planner by checking id
                            if (c.class !== undefined && o.class.classNo === c.class.classNo ||
                                c.hasOwnProperty('classNo') &&
                                o.id.indexOf(c.classNo.toString()) === 0) {
                                classNo = o.class.classNo;
                                courseId = o.courseId;
                                hour.classes.splice(hour.classes.indexOf(o), 1);

                                checkDayForClashes(day, false);
                            }
                        }
                        if (Object.size(hour.classes) > 0) {
                            hasClasses = true;
                        }
                    }
                }
                if (!hasClasses) {
                    data.planner[i].hasClasses = false;
                }
            }

            data.addedToPlanner = data.addedToPlanner.where(function (p) {
                return p.class !== undefined ? p.class.classNo !== classNo : p.courseId !== courseId;
            });

            storageService.storePlanner(data.addedToPlanner);

            notify();
        }
    }


    /**
     * execute the actual removal from the planner, once the previous function has completed its modifications
     * @param {} c 
     * @returns {} 
     */
    function doRemoveFromPlanner(c) {

        data.addedToPlanner = data.addedToPlanner.filter(function (p) {
            return p.courseCode !== c && p.courseCode !== c.courseCode; // c could be a code or course object
        });

        var i, j, k, l, m, o, day, hasClasses, hour;

        for (i = 0, j = data.planner.length; i < j; i++) {

            day = data.planner[i];
            hasClasses = false;

            for (k = 0, l = Object.size(day.hours); k < l; k++) {

                hour = day.hours[Object.keys(day.hours)[k]];
                m = Object.size(hour.classes);

                if (m > 0) {
                    while (m--) {
                        o = hour.classes[m];
                        if (o.courseCode === c || o.courseCode === c.courseCode) {
                            hour.classes.splice(hour.classes.indexOf(o), 1);
                            checkDayForClashes(day, false);
                        }
                    }
                }
                if (Object.size(hour.classes) > 0) {
                    hasClasses = true;
                }
            }
            if (!hasClasses) {
                data.planner[i].hasClasses = false;
            }
        }

        storageService.storePlanner(data.addedToPlanner);
        notify();
    }

    /**
     * 
     * @param {} courseCode 
     * @param {} description 
     * @param {} courseId 
     * @param {} termId 
     * @param {} checkUnique 
     * @returns {} 
     */
    function addCourseToPlanner(courseCode, description, courseId, termId, checkUnique) {

        var exists = false;
        if (checkUnique) {
            exists = data.addedToPlanner.where(function (el) {
                return el.courseCode === courseCode;
            }).length;
        }
        /*if it's not currently added then add this from current courses or if it's not existed in the current courses send */
        if (!exists) {

            var course = {
                courseCode: courseCode,
                description: description,
                termId: termId,
                courseId: courseId
            };

            data.addedToPlanner.push(course);

            alertsService.add('success', 'SUCCESS', 'Course <i>' + course.description + '</i> successfully added to planner.');
        }
    }

    /**
     * Removes all classes from the planner by emptying the containing array
     * @returns {} 
     */
    function clearPlannerUi() {
        var i, j;
        for (i = 0; i < timetableConfig.DAYS.length; i++) {
            for (j = 0; j < 15; j++) {
                if (data.planner[i] && data.planner[i].hours[j]) {
                    data.planner[i].hours[j].classes = [];
                }
            }
        }
    }

    /**
     * Fetch the planner from localstorage, then validated included classes against the current offering for the selected term
     */
    function getFromLocalStorage() {

        data.addedToPlanner = storageService.getPlanner();

        // Matt Crawford            
        // Create an array for verification at the server side of the existance of a course
        if (data.addedToPlanner && data.addedToPlanner.length > 0) {
            var indexes = [];

            angular.forEach(data.addedToPlanner,
                function (item) {

                    if (!indexes[item.termId]) {
                        indexes[item.termId] = [];
                    }

                    if (indexes[item.termId.toString()].indexOf(item.courseId.toString()) === -1) {
                        indexes[item.termId.toString()].push(item.courseId.toString());
                    }
                });

            // Load the matching items from the server
            if (indexes.length > 0) {
                angular.forEach(indexes, function (courseIds, term) {
                    timetableService.getClassBySearchTerm(courseIds, term).then(function (cls) {
                        if (cls.data.data && cls.data.data.length > 0) {

                            var updateUi = false;

                            // Iterate through each item that has been added to the planner
                            for (var addedItem = 0; addedItem < data.addedToPlanner.length; addedItem++) {
                                var scopeItem = data.addedToPlanner[addedItem];

                                // Iterate through the multi dimental array of data return from the server
                                var found = false;
                                for (var serverDs = 0; serverDs < cls.data.data.length; serverDs++) {

                                    var serverData = cls.data.data[serverDs].value;
                                    for (var item = 0; item < serverData.length; item++) {
                                        var serverItem = serverData[item];
                                        if (serverItem.enrolmentStatus === 'C' && !$rootScope.godMode)
                                            continue;

                                        if (scopeItem.courseCode === serverItem.courseCode &&
                                            scopeItem.courseId === serverItem.courseId &&
                                            scopeItem.class.classSection ===
                                            serverItem.classSection) {
                                            // We have found the item
                                            found = true;
                                            break;
                                        }
                                    }

                                    if (found)
                                        break;
                                }

                                if (!found) {
                                    data.addedToPlanner.splice(addedItem, 1);
                                    updateUi = true;
                                }
                            }

                            // Store the results if we have removed anything and refresh the UI
                            // This needs to be called due to the asyncronis nature of this call,
                            // The add items code below will be called before we get here
                            if (updateUi) {

                                storageService.storePlanner(data.addedToPlanner);
                                clearPlannerUi();

                                for (var j = 0, l = data.addedToPlanner.length; j < l; j++) {
                                    var c = data.addedToPlanner[j];
                                    if (c.hasOwnProperty('class')) {
                                        addClassToPlanner(c.class,
                                            c.courseCode,
                                            c.description,
                                            c.courseId,
                                            c.termId,
                                            true);
                                    } else {
                                        addCourseToPlanner(c.courseCode,
                                            c.description,
                                            c.courseId,
                                            c.termId,
                                            true);
                                    }
                                }
                            }
                        }
                    });
                });
            }
        }
        // Add items to the planner now
        if (data.addedToPlanner !== null) {
            for (var j = 0, l = data.addedToPlanner.length; j < l; j++) {
                var c = data.addedToPlanner[j];
                if (c.hasOwnProperty('class')) {
                    addClassToPlanner(c.class, c.courseCode, c.description, c.courseId, c.termId, true);
                } else {
                    addCourseToPlanner(c.courseCode, c.description, c.courseId, c.termId, true);
                }
            }
        } else {
            data.addedToPlanner = [];
        }

        notify();
    }

    /**
     * Generic function to return the current state
     */
    function get() {
        return data;
    }

    /**
     * Return an array of class ids, for the classes added to the current planner view
     * @returns {} 
     */
    function getSelectedClassIds() {
        return data.addedToPlanner.map(function (v) {
            return v.id;
        });
    }

    return {
        addToPlanner: addToPlanner,
        get: get,
        removeFromPlanner: removeFromPlanner,
        clearPlannerUi: clearPlannerUi,
        getFromLocalStorage: getFromLocalStorage,
        getSelectedClassIds: getSelectedClassIds,
        scaffold: scaffold,
        notify: notify
    }
};